<template>
  <div class="row">
    <div class="col-md-12">
      <p  class="clearfix"></p>
      <product-form
        :productData="productData"
        :mainCategoriesParent="mainCategories"
        :taxesParent="taxes"
        :kdsSectionsParent="kdsSections"
        :productOptionsParent="productOptions"
        :companyProductFilters="companyProductFilters"
        :measurementsUnits="measurementsUnits"
        :language="language"
        :languages="languages"
        :route="route"
        @on-submit="onProductSubmit"
      />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {Select, Option} from 'element-ui'
import ProductForm from './ProductForm.vue'
import { loadProductFormDependencies } from './productFormDependencies.js'
Vue.use(Select)
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ProductForm
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      productData: this.route.params.productData || {},
      mainCategories: this.route.params.mainCategories || [],
      taxes: this.route.params.taxes || [],
      kdsSections: this.route.params.kdsSections || [],
      productOptions: this.route.params.productOptions || [],
      companyProductFilters: this.route.params.companyProductFilters || [],
      measurementsUnits: this.route.params.measurementsUnits || [],
      language: this.route.params.language || '',
      languages: this.route.params.languages || [],
      categoryModel: {},
      category: {},
      modelValidations: {
        required: {
          required: true
        }
      }
    }
  },
  created () {
    loadProductFormDependencies(this)
  },
  methods: {
    onProductSubmit (model, isValid) {
      this.productModel = model
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/ProductEdit.vue